import * as React from 'react';
import PropTypes from 'prop-types';

const SvgSportsRockClimbingNormalXsmall = React.forwardRef(
  ({ color, size, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M.5 9.654A2.452 2.452 0 002.949 12.1c.387 0 .77-.073 1.129-.217a5.447 5.447 0 012.036-.392H6.4c.54 0 1.08.063 1.606.187l5.65 1.339a1.5 1.5 0 001.848-1.46 4.2 4.2 0 00-1.58-3.3L7.939 3.47a1.366 1.366 0 00-1.995.41L5.05 5.563a.675.675 0 01-.6.358h-.204l-.512-.96.412-.494a1.158 1.158 0 10-1.913-.2l.286.536-.019.021a6.784 6.784 0 00-2 4.83zM2.949 11.1A1.45 1.45 0 011.5 9.654a5.8 5.8 0 01.164-1.306l1.456 2.739c-.057.005-.113.013-.171.013zm11.551.458a.5.5 0 01-.613.485l-5.651-1.335a7.988 7.988 0 00-1.549-.2l-.625-1.174 8.412 1.992c.006.079.026.155.026.235zm-1.2-2.511c.394.319.708.726.915 1.189L11.522 9.6l.968-1.2zm-1.59-1.271l-1.267 1.568-1.5-.354 1.667-2.1zM9.831 6.269L7.869 8.735l-1.514-.359L8.748 5.4zm-3.9-.237l.894-1.683a.332.332 0 01.486-.1l.655.524-2.605 3.243-.6-1.136a1.657 1.657 0 001.172-.848zM3.12 3.645a.154.154 0 01.219-.05.159.159 0 01.038.232l-.15.18-.111-.207a.152.152 0 01.004-.155zm-.106 2.09l.029.056.6 1.131 1.913 3.6c-.493.044-.98.144-1.45.3L2.123 7.081c.233-.488.533-.94.891-1.346z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalXsmall.defaultProps = {
  color: 'currentColor',
  size: 16,
  title: undefined,
  titleId: undefined
};
SvgSportsRockClimbingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  title: PropTypes.string,
  titleId: PropTypes.string
};
export default SvgSportsRockClimbingNormalXsmall;
